import { NgModule } from '@angular/core';
import { ContextComponent } from './components/context.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { BlockedComponent } from './components/blocked/blocked.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { AdviceNonhappyFlowComponent } from './components/advice-nonhappy-flow/advice-nonhappy-flow.component';
import { LoginAgnosticComponent } from './components/login-agnostic/login-agnostic.component';

@NgModule({
    declarations: [
        ContextComponent,
        BlockedComponent,
        UnsubscribeComponent,
        AdviceNonhappyFlowComponent,
        LoginAgnosticComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ]
})
export class ContextModule { }
